export enum QuoteStep {
  QuoteDetails = 1,
  ProductList = 2,
  PaymentDetails = 3
}

export enum QuoteSection {
  Products = 'products',
  Notifications = 'notifications',
  Payment = 'payment',
  Options = 'options'
}
